import cx from 'classnames'

import { ReactComponent as Chevron } from 'assets/icons/chevronRight24.svg'
import { ReactComponent as Logo } from 'assets/icons/logo40.svg'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

import Styles from './LinkCards.module.scss'

interface DemoCardProps {
  transitionPage: (page: string) => void
}

export const DemoCard = ({ transitionPage }: DemoCardProps) => {
  const { isTabletPortrait } = useResponsiveDesign()

  return (
    <div onClick={() => transitionPage('GO_BACK')} className={Styles.option}>
      <div className={cx(Styles.left, Styles.purple, { [Styles.mobile]: isTabletPortrait })}>
        <Logo />
      </div>
      <div className={Styles.right}>
        <div className={Styles.optionTitle}>Want to skip the line?</div>
        <div className={Styles.optionSubtitle}>Complete a 30 min onboarding session.</div>
      </div>
      <div className={Styles.chevronContainer}>
        <Chevron />
      </div>
    </div>
  )
}
